import { AnyAction } from 'redux';
import { ReduxAction } from '../../enums/const-enums';

export const setEmailAddress = (emailAddress: string): AnyAction => {
  return {
    type: ReduxAction.SET_EMAIL_ADDRESS,
    payload: { emailAddress },
  };
};

export const setIsEmailAddressRemembered = (
  isEmailAddressRemembered: boolean,
): AnyAction => {
  return {
    type: ReduxAction.SET_IS_EMAIL_ADDRESS_REMEMBERED,
    payload: { isEmailAddressRemembered },
  };
};
